import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import ReactHtmlParser from 'react-html-parser'
import ContentBlock from 'components/atoms/ContentBlock'
import Typography from 'components/atoms/Typography'
import SectionFilterPlanOptions from 'components/molecules/SectionFilterPlanOptions'
import PlanList from 'components/molecules/PlanList'
import { useDispatch, useSelector } from 'react-redux'
import * as customPageActions from 'store/modules/customPage/actions'
import { sortBy, get, isEmpty, isEqual } from 'lodash'
// Style
import './PlanWidget.scss'

function PlanWidget({ data }) {
  const dispatch = useDispatch()
  const segmentId = get(data, 'segment[0].entity.tid')
  const uuid = get(data, 'uuid')
  const id = get(data, 'id')
  const removeFilters = get(data, 'removeFilters')
  const themeClasses = get(data, 'theme.entity.classes')

  const {
    plans: plansData,
    loadingPlans,
    planFilters: planFiltersData,
  } = useSelector(({ customPage }) => customPage, isEqual)

  const [categories, setCategories] = useState([])
  const [plans, setPlans] = useState(
    plansData[uuid]?.plansBySegmentQuery?.entities || plansData[uuid]?.plansByCategoryQuery?.entities
  )
  const [planFilter, setPlanFilter] = useState([])
  const [initialPlans, setInitialPlans] = useState(plansData)

  const handleChangeFilter = (value) => {
    if (Array.isArray(value)) {
      setCategories(value)
    } else {
      let newValues = [...categories]
      const index = newValues.findIndex((i) => i === value)
      index >= 0 ? newValues.splice(index, 1) : newValues.push(value)
      setCategories(newValues)
    }
  }

  useEffect(() => {
    if (plansData[uuid])
      setInitialPlans(plansData[uuid]?.plansBySegmentQuery?.entities || plansData[uuid]?.plansByCategoryQuery?.entities)
  }, [plansData, uuid])

  useEffect(() => {
    if (isEmpty(planFiltersData) && !removeFilters) {
      dispatch(customPageActions.getPlanFilters({ limit: 10 }))
    }
  }, [])

  useEffect(() => {
    if (!window.__SERVER_SIDE__) {
      dispatch(
        customPageActions.getPlans({
          uuid,
          segment: segmentId,
          categories: categories.map((c) => `${c}`),
        })
      )
    }
  }, [categories])

  useEffect(() => {
    const plansBySegment = get(plansData[uuid], 'plansBySegmentQuery.entities')
    const plansByCategory = get(plansData[uuid], 'plansByCategoryQuery.entities')

    if (loadingPlans[uuid]) return setPlans([])
    if (plansByCategory) {
      setPlans(plansByCategory)
    } else if (plansBySegment) {
      setPlans(plansBySegment)
    } else {
      setPlans([])
    }
  }, [plansData, loadingPlans[uuid]])

  useEffect(() => {
    setPlanFilter(get(planFiltersData, 'plansFiltersQuery.entities', []))
  }, [planFiltersData])

  return (
    <>
      <Container id={id} fluid="fluid" className={`plan-widget ${themeClasses} `}>
        <Container>
          <Row className="py-4">
            <Col sm={12}>
              <ContentBlock>
                <Typography variant="h4" cssClass="title-bold-md plan-widget-title">
                  {get(data, 'title')}
                </Typography>
                <Typography variant="span" color="gray-100" cssClass="mt-2">
                  {ReactHtmlParser(get(data, 'description.value'))}
                </Typography>
              </ContentBlock>
            </Col>
          </Row>
          {!removeFilters && initialPlans.length > 0 && planFilter.length > 0 && (
            <SectionFilterPlanOptions
              items={planFilter}
              onChangeFilter={(id) => handleChangeFilter(id)}
              itemsActive={categories}
              plans={initialPlans}
            />
          )}
          {loadingPlans[uuid] && (
            <div className="py-4">
              <Spinner className="d-flex justify-content-center" animation="border" size="lg" />
            </div>
          )}
          {Array.isArray(plans) && plans.length > 0 && (
            <Row className="mt-4">
              <Col sm={12}>
                <PlanList items={sortBy(plans, ['title'])} />
              </Col>
            </Row>
          )}
        </Container>
      </Container>
    </>
  )
}

export default PlanWidget
